import styled from 'styled-components';

export const StyledNotificationContainer = styled.div`
  margin-right: 24px;
  margin-top: 72px;
  position: fixed;
  top: 0;
  right: 0;
  max-width: 30vw;
  width: 500px;
  z-index: 10;
`;
